const ChatbotTabContent: React.FC = () => {
	return <div className="max-w-2xl">Chatbot...</div>;
};

export default ChatbotTabContent;
